@if (state() !== 'error') {
  @let loading = state() === 'loading';

  <button
    type="button"
    class="flex items-center justify-center gap-2 w-full py-4 rounded-full font-bold text-xl md:text-base text-white bg-cp-secondary-100 disabled:opacity-70 disabled:cursor-wait"
    [disabled]="loading"
    [attr.aria-busy]="loading ? 'true' : null"
    (click)="antrag.emit()"
  >
    @if (loading) {
      <mat-spinner [diameter]="20" />
      <span>Lade Preis und Dokumente...</span>
    } @else {
      Zum Antrag
    }
  </button>
}
